import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ReactLenis from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";

function App() {
  useEffect(() => {
    document.title = "Qonnect QA — Engineering trust, delivering quality";
  }, []);

  return (
    <div className="App bg-noise">
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="light" richColors />
      </ReactLenis>
    </div>
  );
}

export default App;
